<template>
  <div class="main">
    <Header :show="show" @listenEvent="fn" @listenHeight="getHeight" />
    <div class="imgshowbox" @click="changeShow" :style="'margin-top:' + msgboxTop + 'px'">
      <div class="container">
        <img class="titleimg" src="../assets/images/topImg/16.jpg" alt="" />
        <div class="title-box">
          <div class="title-box-bottom">
            <h3 class="big-title">AI智能多目摄像机模组</h3>
            <p class="title-details">
              长焦和短焦配合，可看全局，可看细节。可实现实时预览画面快速变焦放大，无延迟，对焦快又准。支持多目画中画、AI智能检测、语音对讲、云存储等功能。
            </p>
            <!-- <van-button
              v-show="showVideo"
              round
              class="title-box-bottom-video"
              @click="
                () => {
                  this.$router.push({
                    name: 'video',
                    query: {
                      src: 'http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4'
                    }
                  });
                }
              "
            >
              <van-icon :name="require('../assets/images/play.png')" />
              <span>圆形按钮</span>
            </van-button> -->
          </div>
        </div>
      </div>
      <div>
        <van-tabs v-model="active" swipeable animated>
          <van-tab v-for="item in messageList" :key="item.id" :title="item.title">
            <div class="product-box">
              <div class="product-box-top">
                <p class="product-title">
                  {{ item.details }}
                </p>

                <div class="product-button">
                  <span v-for="list in item.buttonList" :key="list.id">
                    <router-link :to="{ path: list.url, query: { src: list.src } }">
                      <van-button class="title-box-bottom-video change-color" round
                        ><van-icon :name="list.icon"></van-icon>
                        <span class="button-in-box">{{ list.text }}</span>
                      </van-button>
                    </router-link>
                  </span>
                </div>
              </div>

              <div
                class="product-box-middle"
                v-for="article in item.articleList"
                :key="article.id"
              >
                <div class="img-box">
                  <van-image width="100%" fit="contain" :src="article.src" />

                  <div>
                    <h4>{{ article.articletitle }}</h4>
                    <span class="product-details">{{ article.articledetails }} </span>
                    <div v-for="list in article.traitList" :key="list.id">
                      <h5>{{ list.lightTitle }}</h5>
                      <p v-for="(light, index) in list.lightList" :key="index">
                        {{ light.light }}
                      </p>
                    </div>
                  </div>
                  <p class="linkmore" v-show="article.have">
                    <a :href="article.href">了解更多>>></a>
                  </p>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
export default {
  components: { Header },
  data() {
    return {
      src: "/video",
      show: false,
      active: 0,
      showVideo: true,
      msgboxTop: 0,

      messageList: [
        {
          id: 1,
          title: "AI双目变焦摄像机模组",
          details: "",
          buttonList: [
            // {
            //   id: 1 - 1,
            //   icon: require("../assets/images/play.png"),
            //   text: "播放视频1",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // },
            // {
            //   id: 1 - 2,
            //   icon: require("../assets/images/ppt.png"),
            //   text: "播放视频3",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // }
          ],
          articleList: [
            {
              id: 1 - 1 - 1,
              src: require("../assets/images/newAdd/46.jpg"),
              articletitle: "400万双目WiFi球机模组",
              articledetails: "",
              traitList: [
                {
                  id: 1 - 1 - 1 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "400万分辨率，图像清晰，细腻",
                    },
                    {
                      light: "支持双目8倍混合变焦",
                    },
                    {
                      light: "支持画中画显示",
                    },
                    {
                      light: "支持连接有线和无线网络连接",
                    },
                    {
                      light: "支持双光，支持人形、智能（拌线，区域看护等）",
                    },
                    {
                      light: "先进的H.265AI视频压缩技术，超低码率，高清画质",
                    },
                    {
                      light: "支持手机监控，报警信息推送",
                    },
                    {
                      light: "支持TF卡存储/云存储",
                    },
                    {
                      light: "支持DC12V供电",
                    },
                  ],
                },
                // {
                //   id: 1 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "适用于公安、交通、司法、楼宇、金融、能源、教育等行业整体视频监控项目"
                //     }
                //   ]
                // }
              ],
              have: true,
              href: "https://www.xiongmaitech.com/product/product-list/212",
            },
            {
              id: 1 - 1 - 2,
              src: require("../assets/images/newAdd/47.jpg"),
              articletitle: "800万双目WiFi球机模组",
              articledetails: "",
              traitList: [
                {
                  id: 1 - 1 - 2 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "800万分辨率，图像清晰，细腻",
                    },
                    {
                      light: "支持双目8倍混合变焦",
                    },
                    {
                      light: "支持画中画显示",
                    },
                    {
                      light: "支持连接有线和无线网络连接",
                    },
                    {
                      light: "支持双光，支持人形、智能（拌线，区域看护等）",
                    },
                    {
                      light: "先进的H.265AI视频压缩技术，超低码率，高清画质",
                    },
                    {
                      light: "支持手机监控，报警信息推送",
                    },
                    {
                      light: "支持TF卡存储/云存储",
                    },
                    {
                      light: "支持DC12V供电",
                    },
                  ],
                },
                // {
                //   id: 1 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "适用于公安、交通、司法、楼宇、金融、能源、教育等行业整体视频监控项目"
                //     }
                //   ]
                // }
              ],
              have: true,
              href: "https://www.xiongmaitech.com/product/product-list/212",
            },
            {
              id: 1 - 1 - 3,
              src: require("../assets/images/newAdd/48.jpg"),
              articletitle: "400万双目有线球机模组",
              articledetails: "",
              traitList: [
                {
                  id: 1 - 1 - 3 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "400万分辨率，图像清晰，细腻",
                    },
                    {
                      light: "支持双目8倍混合变焦",
                    },
                    {
                      light: "支持画中画显示",
                    },
                    {
                      light: "支持人脸抓拍，人形检测等智能功能",
                    },

                    {
                      light: "先进的H.265AI视频压缩技术，超低码率，高清画质",
                    },
                    {
                      light: "支持手机监控，报警信息推送",
                    },
                    {
                      light: "支持TF卡存储",
                    },
                    {
                      light: "支持一键复位",
                    },
                  ],
                },
                // {
                //   id: 1 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "适用于公安、交通、司法、楼宇、金融、能源、教育等行业整体视频监控项目"
                //     }
                //   ]
                // }
              ],
              have: true,
              href: "https://www.xiongmaitech.com/product/product-detail/198/259/528",
            },
            {
              id: 1 - 1 - 4,
              src: require("../assets/images/newAdd/49.jpg"),
              articletitle: "800万双目有线球机模组",
              articledetails: "",
              traitList: [
                {
                  id: 1 - 1 - 4 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "800万分辨率，图像清晰，细腻",
                    },
                    {
                      light: "支持双目8倍混合变焦",
                    },
                    {
                      light: "支持画中画显示",
                    },
                    {
                      light: "支持人脸抓拍，人形检测等智能功能",
                    },

                    {
                      light: "先进的H.265AI视频压缩技术，超低码率，高清画质",
                    },
                    {
                      light: "支持手机监控，报警信息推送",
                    },
                    {
                      light: "支持TF卡存储",
                    },
                    {
                      light: "支持一键复位",
                    },
                  ],
                },
                // {
                //   id: 1 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "适用于公安、交通、司法、楼宇、金融、能源、教育等行业整体视频监控项目"
                //     }
                //   ]
                // }
              ],
              have: true,
              href: "https://www.xiongmaitech.com/product/product-detail/198/259/529",
            },
          ],
        },
        {
          id: 2,
          title: "AI双目拼接摄像机模组",
          details: "",
          buttonList: [
            // {
            //   id: 1 - 1,
            //   icon: require("../assets/images/play.png"),
            //   text: "播放视频1",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // },
            // {
            //   id: 1 - 2,
            //   icon: require("../assets/images/ppt.png"),
            //   text: "播放视频3",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // }
          ],
          articleList: [
            {
              id: 2 - 1 - 1,
              src: require("../assets/images/newAdd/51.jpg"),
              articletitle: "400万双目拼接WiFi枪机模组",
              articledetails: "",
              traitList: [
                {
                  id: 2 - 1 - 1 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "400万分辨率，图像清晰，细腻",
                    },
                    {
                      light: "支持画中画显示",
                    },
                    {
                      light: "支持连接有线和无线网络连接",
                    },
                    {
                      light: "支持双光，支持人形、智能（拌线，区域看护等）",
                    },
                    {
                      light: "支持2D/3D降噪，数字宽动态",
                    },
                    {
                      light: "先进的H.265AI/H.265+视频压缩技术，超低码率，高清画质",
                    },
                    {
                      light: "支持ONVIF协议，可接入第三方后端/平台",
                    },

                    {
                      light: "支持手机监控，报警信息推送至手机等功能",
                    },
                    {
                      light: "支持TF卡存储/云存储",
                    },
                    {
                      light: "支持DC12V供电",
                    },
                  ],
                },
                // {
                //   id: 1 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "适用于公安、交通、司法、楼宇、金融、能源、教育等行业整体视频监控项目"
                //     }
                //   ]
                // }
              ],
              have: true,
              href: "http://www.jufenginfo.com/product-list-6-26.html",
            },
            {
              id: 2 - 1 - 2,
              src: require("../assets/images/newAdd/52.jpg"),
              articletitle: "400万双目拼接有线枪机模组",
              articledetails: "",
              traitList: [
                {
                  id: 2 - 1 - 2 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "400万分辨率，图像清晰，细腻",
                    },
                    {
                      light: "支持画中画显示",
                    },

                    {
                      light: "支持双光，支持人形、智能（拌线，区域看护等）",
                    },

                    {
                      light: "支持2D/3D降噪，数字宽动态",
                    },
                    {
                      light: "先进的H.265AI/H.265+视频压缩技术，超低码率，高清画质",
                    },
                    {
                      light: "支持ONVIF协议，可接入第三方后端/平台",
                    },
                    {
                      light: "支持手机监控，报警信息推送至手机等功能",
                    },
                    {
                      light: "支持TF卡存储",
                    },
                    {
                      light: "支持长按复位",
                    },
                  ],
                },
                // {
                //   id: 1 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "适用于公安、交通、司法、楼宇、金融、能源、教育等行业整体视频监控项目"
                //     }
                //   ]
                // }
              ],
              have: true,
              href: "http://www.jufenginfo.com/product-list-6-26.html",
            },
          ],
        },
      ],
    };
  },
  methods: {
    changeShow() {
      this.show = false;
    },
    fn(val) {
      this.show = val;
    },
    getHeight(val) {
      this.msgboxTop = val;
    },
  },
  watch: {
    msgboxTop(val) {
      this.msgboxTop = val;
    },
  },
};
</script>

<style></style>
